import React from "react";
import "./style.css";
import {QuestionnaireSelect} from "../../../../components/QuestionnaireSelect";
import {RESULTS_TIMING} from "../../../../const/WeightLossQuestionnaire";

export const ResultsTiming = (props) => {
  const data = {
    title: "When would you like to see results?",
    list: RESULTS_TIMING
  };

  return (
    <div className="gallery-page">
      <QuestionnaireSelect list={data} {...props} />
    </div>
  );
};
